export default __webpack_public_path__ + "static/media/10.aefea429.svg";